import styled from "styled-components";

export const Container = styled.div `
    position: fixed;
    padding: 50px 30px;
    background-image: linear-gradient(to bottom right, #181818, #303030);
    width: 100%;
    height: 100dvh;
    overflow-y: auto;
    z-index: 999;

    .loading {
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        background: #181818;
        width: 100%;
        height: 100%;
        z-index: 2;
    }
`

export const Content = styled.div `

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    opacity: ${props => props.loadingProfiles ? 0 : 1};
    transition: all 1s ease;

    .title-welcome {
        font-size: 3rem;
        margin-bottom: 20px;
    }

    .number-profiles span {
        font-size: .8rem;
        font-weight: 600;
    }

    .footer-profiles {
        margin-top: 10px;
    }

    .footer-profiles button {
        margin-right: 10px;
        border-radius: 5px;
        padding: 10px 25px;
        font-size: 1rem;
        border: none;
        background: #fff;
        color: #181818;
        font-weight: 600;
        border: 2px solid transparent;
        cursor: pointer;
        transition: all .3s ease;
    }

    .footer-profiles button:hover {
        opacity: .7;
    }

    .footer-profiles button:nth-child(2) {
        background: unset;
        color: #fff;
        border: 2px solid #ccc;
        margin-right: 0;
    }

    @media (max-width: 700px) {
        .title-welcome {
            font-size: 2rem;
            margin-bottom: 20px;
        }
    }

    @media (max-width: 500px) {

        .footer-profiles {
            display: flex;
            flex-direction: column;
            width: 100%;
            max-width: 230px;
        }

        .footer-profiles button {
            margin: 0 0 5px 0;
            width: 100%;
        }
    }

    @media (max-width: 400px) {

        .footer-profiles {
            width: 100%;
        }

        .title-welcome {
            font-size: 1.5rem;
            text-align: center;
        }
    }

    @media (max-width: 300px) {

        .title-welcome {
            font-size: 1.2rem;
        }

        .footer-profiles button {
            font-size: .8rem;
        }
    }
`

export const Profiles = styled.div `
    display: flex;
    align-items: start;
    margin-bottom: 10px;

    .div-add-profile {
        margin-top: 5px;
    }

    .add-profile {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
        cursor: pointer;
        font-size: .8rem;
        height: 130px;
        font-weight: 600;
        margin: auto;
        width: 130px;
        background: none;
        color: #bbb;
        border: 2px solid #505050;
        transition: all .3s ease;
    }

    .add-profile:hover {
        color: #fff;
        border-color: #fff;
    }

    .add-profile i {
        font-size: 3rem;
        margin-bottom: 10px;
    }

    @media (max-width: 700px) {
        display: grid;
        grid-template-columns: repeat(2, 1fr); /* Dois itens por linha */
        gap: 10px;
    }

    @media (max-width: 500px) {
        display: grid;
        grid-template-columns: repeat(2, 1fr); /* Dois itens por linha */
        gap: 10px;
        width: 100%;
        max-width: 230px;

        .div-add-profile {
            height: 100%;
        }

        .add-profile {
            font-size: .7rem;
            height: 100%;
            height: 140px;
            max-height: 67%;
            width: 90%;
        }

        .add-profile i {
            font-size: 1.8rem;
        }
    }

    @media (max-width: 250px) {

        .add-profile {
            height: 130px;
            max-height: 60%;
            font-size: .65rem;
        }

        .add-profile i {
            font-size: 1.5rem;
        }
    }

`

export const Profile = styled.div `

    position: relative;
    display: flex;
    flex-direction: column;
    margin-right: 20px;

    &:last-child {
        margin-right: 0;
    }

    .profile {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: ${props => props.disabled ? 'default' : 'pointer'};
        padding: 2px 2px 10px 2px;
        border-radius: 5px;
        background: unset;
        color: #fff;
        transition: all .3s ease;
        border: 2px solid transparent;
    }
    
    .profile:hover {
        background: ${props => props.disabled ? 'unset' : '#505050'};
    }
    
    .div-img-profile {
        position: relative;
        margin-bottom: 10px;
        width: 100%;
        height: 100%;
        max-width: 230px;
    }

    img {
        border-radius: 5px;
        max-height: 130px;
        min-height: 130px;
        min-width: 130px;
        max-width: 130px;
        background: #303030;
        object-fit: cover;
        border: 2px solid transparent;
        transition: all .3s ease;
    }

    .edit-profile {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        cursor: pointer;
        font-size: 1.2rem;
        border-radius: 5px;
        background-color: #181818aa;
        border: 2px solid transparent;
        color: #fff;
        transition: all .3s ease;
    }

    .edit-profile:hover {
        background: #181818cc;
        border-color: #fff;
    }

    .name {
        font-weight: 600;
    }

    .delete-profile {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: .8rem;
        font-weight: 600;
        border: none;
        border-radius: 5px;
        padding: 10px 10px;
        margin: 5px 0;
        cursor: pointer;
        width: 100%;
        transition: all .3s ease;
    }

    .delete-profile i, .edit-profile i {
        margin-right: 5px;
    }

    .delete-profile:hover{
        opacity: .8;
    }

    .delete-profile {
        background-color: #e50914;
        color: #fff;
    }

    @media (max-width: 700px) {
        margin-right: 0;
    }

    @media (max-width: 500px) {
        img {
            max-height: 100%;
            min-height: 100%;
            min-width: 100%;
            max-width: 100%;
        }
    }

    @media (max-width: 450px) {

        .name {
            font-weight: 600;
        }
    }
    @media (max-width: 300px) {

        .name {
            font-weight: 600;
        }
    }

`